import _ from "lodash";
import { dispatchError } from "Utils";
import client from "lib/apolloClient/client";
import {
  AUTH_AND_EVAL,
  CURRICULUM_PROGRAM,
  IBIS_REGISTRATION_REVAMP,
  LIBRARY,
  MESSAGING,
  ORGANIZATION,
  TODDLE_AI,
  TODDLE_ANALYTICS,
} from "./AddOnManagerConstants";
import { setToastMsg } from "Login/modules/LoginModule";

import { bulkManageAddOnsMutation } from "./AddOnManagerMutations";
import { prepareInputFromConfigurationState } from "./AddOnManagerUtils";

const ADD_ON_INPUT_BUILDERS = {
  [IBIS_REGISTRATION_REVAMP]: ({ newStatus, additionalInput }) => ({
    permissionValue: newStatus,
    ...additionalInput,
  }),

  [LIBRARY]: ({ permissions, additionalInput }) => ({
    permissions,
    ...additionalInput,
  }),

  [AUTH_AND_EVAL]: ({ permissions, additionalInput }) => ({
    permissions,
    ...additionalInput,
  }),

  [TODDLE_ANALYTICS]: ({ permissions, additionalInput }) => ({
    permissions,
    ...additionalInput,
  }),

  [TODDLE_AI]: ({ addOnInput }) => addOnInput,
  [MESSAGING]: ({ addOnInput }) => addOnInput,
};

const _getAddOnSettingsInput = mutationInput => {
  const {
    curriculumId,
    newStatus,
    updateOn,
    addOnType,
    moduleId,
    isSingleCurriculumProgramId = false,
    additionalInput = {},
    addOnSubType = "",
    permissions,
    input: addOnInput,
  } = _.isArray(mutationInput) ? _.first(mutationInput) : mutationInput;

  let input = [];

  if (ADD_ON_INPUT_BUILDERS[addOnType]) {
    input = ADD_ON_INPUT_BUILDERS[addOnType]({
      newStatus,
      additionalInput,
      addOnInput,
      permissions,
    });
  } else {
    switch (updateOn) {
      case CURRICULUM_PROGRAM: {
        if (_.isArray(mutationInput)) {
          input = _.flatMap(mutationInput, mi => ({
            state: mi.newStatus,
            curriculumProgramIds: mi.curriculumId,
            moduleId: mi.moduleId,
            type: mi.updateOn,
          }));
        } else {
          input = [
            {
              state: newStatus,
              ...(isSingleCurriculumProgramId
                ? { curriculumId }
                : { curriculumProgramIds: curriculumId }),
              moduleId,
              type: updateOn,
            },
          ];
        }
        break;
      }
      case ORGANIZATION: {
        input = {
          permissionValue: newStatus,
          ...(addOnSubType ? { addOnSubType } : {}),
        };
        break;
      }
    }
  }

  if (_.isEqual(addOnType, IBIS_REGISTRATION_REVAMP)) {
    input = {
      permissionValue: newStatus,
      ...additionalInput,
    };
  }

  return {
    addOnType: addOnType,
    input,
  };
};

export const toggleAddOnsSelection = ({
  configurationState,
  addOnsStatus,
  orgId,
  orgRegion,
}) => {
  return async dispatch => {
    try {
      const genericInput = prepareInputFromConfigurationState(
        configurationState,
        addOnsStatus,
        orgId,
        orgRegion
      );

      if (_.isEmpty(genericInput)) return;

      const addOnSettingsInput = _.map(genericInput, mutationInput =>
        _getAddOnSettingsInput(mutationInput)
      );

      await client.mutate({
        mutation: bulkManageAddOnsMutation,
        variables: {
          input: {
            organizationId: orgId,
            addOnSettings: addOnSettingsInput,
          },
        },
      });

      dispatch(
        setToastMsg({
          msg: "Permissions updated successfully",
          notString: true,
          type: "success",
        })
      );
    } catch (error) {
      console.error("Error toggling add-ons selection:", error);
      dispatchError({
        dispatch,
        customMessage: "Error toggling add-ons selection",
      });
    }
  };
};
